import styled from 'styled-components';

export const ToggleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

export const ToggleLabel = styled.span`
    font-size: 0.9em;
    font-weight: 500;
    margin-left: 4px;
    user-select: none;
`;

export const InfoIcon = styled.span`
    color: #1890ff;
    cursor: help;
    font-size: 0.9em;
    transition: color 0.2s ease;

    &:hover {
        color: #40a9ff;
    }
`;

export const StatusIndicator = styled.div<{ isActive: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.85em;
    font-weight: 500;
    background-color: ${(props) => (props.isActive ? '#fff3e0' : 'transparent')};
    color: ${(props) => (props.isActive ? '#ff9800' : '#666')};
    border: 1px solid ${(props) => (props.isActive ? '#ff9800' : 'transparent')};
    transition: all 0.2s ease;
`;
